module.exports = __webpack_public_path__ + "static/leaves@1.5x-db96e8642a6f07eedc05e17932934fb8.png";